import { Money } from '~/modules/common/components/ListTable/renderers';
import { ProjectFormatter } from '~/modules/billing-invoicing/common/columnFormatters';
import ClientRenderer from './client';
import DateFormatter from './date';
import CreateBill from './createBill';
import RowSelectorFormatter from './RowSelectorFormatter';
import { ProjectManagerFormatter } from './ProjectManagerFormatter';

export default {
  rowSelector: RowSelectorFormatter,
  client: ClientRenderer,
  project: ProjectFormatter,
  projectLeader: ProjectManagerFormatter,
  date: DateFormatter,
  amount: Money,
  createBill: CreateBill,
  description: DateFormatter
};
